import React from 'react';
import * as questionTypes from '../constants/questiontypes';
import RadioButtons from './RadioButtons';
import Checkboxes from './Checkboxes';

const supportedDisplayTypeIds = [questionTypes.RADIOBUTTON, questionTypes.CHECKBOX];

export default function Question({ question, onChange, selectedAnswers }) {
    if (!question || !supportedDisplayTypeIds.includes(question.DisplayTypeId)) {
        throw new Error(`NestableQuestion component does not support a question with the "DisplayTypeId" value: ${question.DisplayTypeId}`);
    }

    if (question.DisplayTypeId === questionTypes.RADIOBUTTON) {
        return (
            <RadioButtons
                label={question.QuestionDisplayText}
                exampleText={question.exampleText}
                questionId={question.QuestionId}
                answers={question.Answers}
                selectedAnswer={Array.isArray(selectedAnswers) ? selectedAnswers[0] : undefined}
                onChange={(questionId, val) => onChange(questionId, [val])}
            />
        );
    }


    if (question.DisplayTypeId === questionTypes.CHECKBOX) {
        return (
            <Checkboxes
                label={question.QuestionDisplayText}
                exampleText={question.exampleText}
                questionId={question.QuestionId}
                answers={question.Answers}
                selectedAnswers={selectedAnswers ?? []}
                onChange={onChange}
            />
        );
    }
}